export default __webpack_public_path__ + "static/media/css3-alt.13e51678.png";